import React, { useState } from 'react';
import api from '../api';
import { notify } from '../components/CustomToast';
import { useNavigate, Link } from 'react-router-dom';
import { FaCheckCircle, FaSlack, FaQuoteLeft } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import Logo from '../assets/logo.png';
import useTitle from '../hooks/useTitle';
import { reconnectEcho } from '../echo';
import { useI18n } from '../i18n';

const Login = () => {
  const { t } = useI18n();
  useTitle('pages.login.meta_title');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: null,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    api
      .post('/login', formData)
      .then((response) => {
        setLoading(false);

        if (response.status) {
          notify(
            'success',
            response.message || t('messages.auth.login_success')
          );

          if (response.data && response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));

            reconnectEcho();

            const pendingInviteToken = sessionStorage.getItem(
              'pending_invite_token'
            );

            setTimeout(() => {
              if (pendingInviteToken) {
                navigate(`/accept-invite/${pendingInviteToken}`);
              } else {
                navigate('/dashboard');
              }
            }, 1000);
          }
        } else {
          notify('error', response.message || t('messages.auth.login_failed'));
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.status === 422) {
          notify('error', t('validation.title'));
          setErrors(err.errors);
        } else if (err.status === 401) {
          notify('error', err.message);
        }
      });
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="left-decoration"></div>

        <div className="login-left-content">
          <div className="brand-logo">
            <img
              src={Logo}
              alt={t('common.app_name')}
              style={{ height: '150px' }}
            />
          </div>

          <div className="quote-section">
            <FaQuoteLeft className="quote-icon" />
            <p className="quote-text">{t('pages.login.quote_text')}</p>
            <div className="testimonial-user">
              {t('pages.login.quote_author')}{' '}
              <FaCheckCircle className="verified-badge" />
            </div>
          </div>

          <div className="left-footer">
            {/* <button className="glass-btn" onClick={() => navigate('/register')}>
              {t('pages.login.register_now')}
            </button> */}
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-container">
          <h1 className="login-title">{t('pages.login.title')}</h1>
          <p className="login-subtitle">{t('pages.login.subtitle')}</p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label className="form-label">
                {t('common.labels.email_address')}
                <span className="required">*</span>
              </label>
              <input
                type="email"
                name="email"
                className={`form-input ${errors.email ? 'is-invalid' : ''}`}
                placeholder={t('forms.placeholders.enter_email')}
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <div className="field-error">{errors.email[0]}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                {t('common.labels.password')}
                <span className="required">*</span>
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className={`form-input ${errors.password ? 'is-invalid' : ''}`}
                  placeholder={t('forms.placeholders.enter_password')}
                  value={formData.password}
                  onChange={handleChange}
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ top: '14px', right: '15px' }}
                >
                  {showPassword
                    ? t('common.actions.hide')
                    : t('common.actions.show')}
                </span>
              </div>
              {errors.password && (
                <div className="field-error">{errors.password[0]}</div>
              )}
              <div style={{ textAlign: 'end', marginTop: '10px' }}>
                <Link
                  to="/forgot-password"
                  className="ui-font-14"
                  style={{
                    color: '#1054D6',
                    textDecoration: 'none',
                    fontWeight: '500',
                  }}
                >
                  {t('pages.login.forgot_password')}
                </Link>
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? (
                <>
                  <span
                    className="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span>{t('common.status.loading')}</span>
                </>
              ) : (
                t('common.actions.login')
              )}
            </button>
          </form>

          {/* <div className="divider">{t('pages.login.or')}</div>

          <div className="social-login">
            <button type="button" className="social-btn">
              <FcGoogle className="social-icon" />
              {t('forms.buttons.login_google')}
            </button>
            <button type="button" className="social-btn">
              <FaSlack className="social-icon" style={{ color: '#4A154B' }} />
              {t('forms.buttons.login_slack')}
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
